import { defineComponent as _defineComponent } from 'vue'
import {computed, onMounted, Ref, ref, watch} from "vue";
import { round } from '@/utils/Helpers';
import { Recipe } from '@/models/Recipes/Recipe';
import {LossType} from "@/models/Recipes/LossType";
import VToggleSwitch from "@/components/vToggleSwitch.vue";
import VPreLoader from "@/components/vPreLoader.vue";
import VModal from "@/components/vModal.vue";
import {useTranslations} from "@/hooks/useTranslations";
import {useNotify} from "@/hooks/useNotify";
import ReportsRepository from "@/utils/API/ReportsRepository";
import { RecipeProfileRowData } from "@/models/Reports/RecipeProfileRowData";
import { NutrientType } from "@/models/Ingredient/NutrientType";

type vMultiColumnReportModalProps = {
  showMultiColumnReportModal: boolean;
  recipe: Recipe;
  isTrial: boolean;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'vMultiColumnReportModal',
  props: {
    showMultiColumnReportModal: { type: Boolean, default: false },
    recipe: null,
    isTrial: { type: Boolean }
  },
  emits: ["on-cancel"],
  setup(__props: any, { emit }: { emit: ({(e: 'on-cancel'): void}), expose: any, slots: any, attrs: any }) {

const props = __props as { showMultiColumnReportModal: boolean, recipe: Recipe, isTrial: boolean };



let translations = ref(useTranslations());

function translate(key: string) {
  return translations.value.get(key);
}

const notifyService = useNotify();


const profileReportRows = ref<RecipeProfileRowData[]>([]);
const countryOptions = computed(() => {
  return [
    {value: '0', name: translate('canada')},
    {value: '1', name: translate('country_us')},
    {value: '2', name: translate('country_uk')},
  ];
});

const isLoading = ref(false);
const useRoundedValues = ref(false);
const selectedCountry: Ref<{name: string, value: string}> = ref(countryOptions.value[0]);

watch(
  () => props.showMultiColumnReportModal,
  (newValue: boolean) => {
    if (newValue) {
      getMultiColumnReportData();
      translations.value = useTranslations();
      selectedCountry.value = countryOptions.value[0];
    }
  }
);

const columns = computed(() => {
  const itemsPerColumn = Math.ceil(profileReportRows.value.length / 3);
  return [
    profileReportRows.value.slice(0, itemsPerColumn),
    profileReportRows.value.slice(itemsPerColumn, itemsPerColumn * 2),
    profileReportRows.value.slice(itemsPerColumn * 2),
  ];
});

onMounted(() => {
  selectedCountry.value = countryOptions.value[0];
});

function closeModal() {
  emit("on-cancel");
}

function onCountryChanged() {
  getMultiColumnReportData();
}

function toggleRoundedDisplay() {
  useRoundedValues.value = !useRoundedValues.value;
  getMultiColumnReportData();
}

function getMultiColumnReportData(){
  isLoading.value = true;

  ReportsRepository.getProfileReportData(
    props.recipe.id,
    Number(selectedCountry.value.value),
    useRoundedValues.value,
  ).then((response) => {
    profileReportRows.value = response.data;
    isLoading.value = false;
  }).catch((error) => {
    isLoading.value = false;
    if (error.response) {
      notifyService.error(
        error.response.data.errorMessages[0].userVisibleMessage || 'Error'
      );
    }
    else {
      notifyService.error(translate("network-error"));
    }
  });

}

const exportMultiColumnReportToExcelURL = computed(() => {
  let url = `${process.env.VUE_APP_BASE_DOMAIN}/api/processes/reports/ProfileReport?`;

  if(props.recipe){
    const queryParams = `recipeId=${props.recipe.id}&country=${selectedCountry.value.value}&rounded=${useRoundedValues.value}&download=true`;
    url += queryParams;
  }

  return url;
});


return { __sfc: true,props, translations, translate, notifyService, emit, profileReportRows, countryOptions, isLoading, useRoundedValues, selectedCountry, columns, closeModal, onCountryChanged, toggleRoundedDisplay, getMultiColumnReportData, exportMultiColumnReportToExcelURL, round, LossType, VToggleSwitch, VPreLoader, VModal, NutrientType }
}

})